module.exports = __webpack_public_path__ + "static/media/getir.fae11a73.png";